"use client"
/* */
import { propsContextSupportingComponents } from '../../components/propTypes/index.mjs';

function isFlowComponentName(something) {
  return typeof something === "string" && propsContextSupportingComponents.includes(something);
}

export { isFlowComponentName };
//# sourceMappingURL=isFlowComponentName.mjs.map
